import { useState } from "react"
import { useQuery } from "@tanstack/react-query"
import { fetchProducts } from "@/api/productService"
const useProducts = ({
  currentPage = 1,
  perPage = 30,
  searchQuery = "",
} = {}) => {
  const [page, setPage] = useState(currentPage)

  const { data, isLoading, isError } = useQuery({
    queryKey: ["products", page, perPage, searchQuery],
    queryFn: ({ signal }) =>
      fetchProducts({ page, perPage, searchQuery }, signal),
    keepPreviousData: true,
  })

  return {
    products: data?.data?.data || [],
    isLoading,
    isError,
    currentPage: page,
    setPage,
  }
}

export default useProducts
